import React from 'react';
import {observer} from "mobx-react";

import styles from "./seperated-cards-list.module.scss"
import classNames from "classnames";

export const SeperatedCardsListCard = observer(({item, terms}) => {
  const {value, title, aliasName} = item;
  return <div className={classNames(styles.card_container)}>
    <bdi className={classNames(styles.value)}>{value}</bdi>
    <div className={classNames(styles.title)}>{title || terms[aliasName]}</div>
  </div>
});

